import React, { ReactNode, ReactElement } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebookSquare } from '@fortawesome/free-brands-svg-icons';
import { LoginSignupView } from '../constants';
import microsoftIcon from './icons/microsoft.png';
// import { OL_ORIGIN } from '../../../../ReduxStorage/location/constants';

import './styles.scss';

const SsoButton = React.memo(
  ({
    label,
    icon,
    onClick,
  }: {
    label: string;
    icon: ReactNode;
    onClick?(event: React.MouseEvent<HTMLButtonElement>): void;
  }): ReactElement => (
    <button
      type="button"
      className="login-signup-sso-options-button"
      onClick={onClick}
    >
      {icon}
      <span>{label}</span>
    </button>
  )
);

declare type SsoOptionsProps = {
  view: LoginSignupView;
};

export const SsoOptions = React.memo(
  ({ view }: SsoOptionsProps): ReactElement => (
    <div className="login-signup-sso-options">
      <SsoButton
        label={
          view === 'login' ? 'Log in with Microsoft' : 'Sign up with Microsoft'
        }
        icon={
          <img
            className="login-signup-sso-options-microsoft-icon"
            src={microsoftIcon}
            alt=""
          />
        }
        onClick={() => {
          window.location.href = `/oauth-redirect/microsoft/?redirect=${window.location.href}`;
        }}
      />
      <SsoButton
        label={
          view === 'login' ? 'Log in with Facebook' : 'Sign up with Facebook'
        }
        icon={
          <FontAwesomeIcon
            icon={faFacebookSquare}
            className="login-signup-sso-options-facebook-icon"
          />
        }
        onClick={() => {
          window.location.href = `/oauth-redirect/facebook/?redirect=${window.location.href}`;
        }}
      />
      <div className="login-signup-sso-options-divider">
        <span>or</span>
      </div>
    </div>
  )
);
